// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {"5068": "773a9d01a73f4ab1","7783": "2f6e9933aadf9bf2",}[chunkId] + ".css"
}